var map = {
	"./404.svg": "a14a",
	"./advice.svg": "6ef9",
	"./article.svg": "d1f6",
	"./book.svg": "6ac0",
	"./bug.svg": "1779",
	"./chart.svg": "c829",
	"./charts.svg": "c99e",
	"./clipboard.svg": "bc35",
	"./component.svg": "56d6",
	"./course.svg": "71c5",
	"./course1.svg": "8d78",
	"./dashboard.svg": "f782",
	"./documentation.svg": "90fb",
	"./download.svg": "4dae",
	"./drag.svg": "9bbf",
	"./edit.svg": "aa46",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-off.svg": "bf89",
	"./eye-on.svg": "ba52",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./favourite.svg": "0873",
	"./file.svg": "b8b2",
	"./folder.svg": "d079",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./guide 2.svg": "2027",
	"./guide.svg": "6683",
	"./hamburger.svg": "bd6a",
	"./icon.svg": "9d91",
	"./international.svg": "17df",
	"./language.svg": "2580",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./location.svg": "1c50",
	"./lock.svg": "ab00",
	"./map.svg": "a13f",
	"./message.svg": "47ff",
	"./money.svg": "3046",
	"./nested.svg": "dcf8",
	"./next.svg": "6e7d",
	"./password.svg": "2a3d",
	"./pause .svg": "592a",
	"./pause.svg": "d46e",
	"./pdf.svg": "f9a1",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./play.svg": "fb4f",
	"./previous.svg": "252b",
	"./qq.svg": "1430",
	"./quote.svg": "2dc9",
	"./resource.svg": "ac7b",
	"./route.svg": "eb9a",
	"./search.svg": "8e8d",
	"./shopping.svg": "12a5",
	"./size.svg": "8644",
	"./star.svg": "708a",
	"./stop.svg": "bdb7",
	"./subject.svg": "fab3",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./theme.svg": "e534",
	"./timeline.svg": "182c",
	"./tree-table.svg": "e7c8",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./wechat.svg": "80da",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";